import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/sysDevApp/page',
method: 'get',
params: query
})
}

export function getDevList(query) {
    return request({
        url: '/api/admin/sysDevApp/all',
        method: 'get',
        params: query
    })
}


export function addObj(obj) {
return request({
url: '/api/admin/sysDevApp',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/sysDevApp/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/sysDevApp/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/sysDevApp/' + id,
method: 'put',
data: obj
})
}
